/**
 * Pure decision logic for the Phase A optimistic end-turn guard.
 *
 * BattleUI flips the turn indicator to "opponent's turn" the instant End Turn is pressed and sets a
 * boolean guard. An accepted authoritative state clears the guard (the echo is the truth). A server
 * `error` carries no authoritative state, so we must restore the indicator from gameState.turn —
 * this function decides whether/what to restore. Kept pure so it can be unit-tested in isolation.
 *
 * @param {boolean} guardActive - true when an optimistic end-turn flip is outstanding
 * @param {{turn?: (string|number)}|null|undefined} authoritativeGameState - latest authoritative state
 * @param {string|number} userId - the local player's id
 * @returns {{ rollback: boolean, yourTurn: boolean }}
 */
export function planOptimisticEndTurnRollback(guardActive, authoritativeGameState, userId) {
  if (guardActive !== true) {
    return { rollback: false, yourTurn: false };
  }
  const yourTurn = String(authoritativeGameState?.turn) === String(userId);
  return { rollback: true, yourTurn };
}
